const ITEMS = [
  "Delta Soils",
  "Cool Evening Air",
  "Fermented with Patience",
  "Honest Blends",
  "Picked by Hand",
  "Small-Lot",
  "Bottled When Ready",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative py-8 border-y border-[rgba(212,175,55,0.15)] overflow-hidden bg-[#0A0908]">
      <div className="marquee-track items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center shrink-0">
                <span className="font-serif-display italic font-light text-2xl sm:text-3xl text-[#6E685E] px-8 whitespace-nowrap">
                  {item}
                </span>
                <span className="w-1.5 h-1.5 rotate-45 bg-[#D4AF37]/60 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
